const routes = [
  {
    path: ["/"],
    exact: true,
    component: "Home",
  },
  {
    path: ["/signin"],
    exact: true,
    component: "SignIn",
  },
  {
    path: ["/contact"],
    exact: true,
    component: "Contact",
  },
  {
    path: ["/feedback"],
    exact: true,
    component: "Feedback",
  },
  {
    path: ["/imprint"],
    exact: true,
    component: "Imprint",
  },
  {
    path: ["/privacy"],
    exact: true,
    component: "PrivacyPolicy",
  },
  {
    path: ["/terms"],
    exact: true,
    component: "Terms",
  },
  {
    component: "PageNotFound",
  },
];

export default routes;
